module.exports = __webpack_public_path__ + "img/marui_kitasenju_banner.3aa4d31c.jpeg";